import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import {
  IconHeart,
  IconUser,
  IconDynamic,
  IconUsers,
  IconAdaptive,
} from '@edulastic/icons'
import {
  themeColor,
  accessibilityColors,
  cardTitleColor,
} from '@edulastic/colors'
// eslint-disable-next-line no-unused-vars
import { LikeIconStyled, EduIf, EduThen, EduElse } from '@edulastic/common'
import { PEAR_ASSESSMENT_CERTIFIED_NAME } from '@edulastic/constants/const/common'
import { testCategoryTypes } from '@edulastic/constants/const/test'
import { sanitizeImgUrl } from '@edulastic/common/src/utils/html'
import { Checkbox } from 'antd'
import {
  Container,
  Inner,
  Footer,
  Author,
  AuthorName,
  Header,
  StyledLink,
  TestInfo,
  ShareIcon,
  AuthorWrapper,
  IconText,
  TagsWrapper,
  PlaylistId,
  StatusRow,
  Qcount,
  MidRow,
  Collection,
  CollectionNameWrapper,
  DynamicIconWrapper,
  StyledIcon,
} from './styled'
import Tags from '../../../src/components/common/Tags'
import { TestStatus } from '../ListItem/styled'
import { getAuthorCollectionMap } from '../../../dataUtils'
import TestStatusWrapper from '../TestStatusWrapper/testStatusWrapper'
import AddRemoveTest from './AddRemoveTestToFolder'
import { onEnterKeyPressHandler } from '../../../../common/utils/helpers'

const TestItemCard = ({
  thumbnail,
  openModal,
  status,
  testId,
  collections,
  // showPremiumTag,
  standardsIdentifiers,
  title,
  collectionName,
  isDocBased,
  summary,
  isDynamicTest,
  authorName,
  testItemId,
  usage,
  isTestLiked,
  handleLikeTest,
  likes,
  isTestRecommendation,
  videoUrl,
  testCategory,
  checked,
  handleCheckboxAction,
  showBulkDistrictCheckbox,
  districtMoveInProgress = false,
}) => {
  const [height, setHeight] = useState(0)
  const ref = useRef(null)
  useEffect(() => {
    setHeight(ref.current.clientHeight)
  }, [ref.current])

  const districtSelectionSelected = !!checked && !!showBulkDistrictCheckbox

  const onCheckboxChange = (e) => {
    if (handleCheckboxAction) {
      handleCheckboxAction(e, { _id: testId, title })
    }
  }

  /** Block bubbling to Container onClick={openModal}; onChange alone does not stop the click event. */
  const stopCardOpen = (e) => {
    e.stopPropagation()
  }

  return (
    <Container
      isTestCard
      src={sanitizeImgUrl(thumbnail)}
      onClick={openModal}
      isTestRecommendation={isTestRecommendation}
      districtSelectionSelected={districtSelectionSelected}
    >
      <OnHoverContainer data-cy="test-hover-container">
        <Header
          isTest
          src={sanitizeImgUrl(thumbnail)}
          isTestRecommendation={isTestRecommendation}
        >
          {testCategory === testCategoryTypes.ADAPTIVE_SECTION_TEST && (
            <div style={{ position: 'absolute', bottom: 0, left: 5 }}>
              <IconAdaptive />
            </div>
          )}
          {collections.find((o) => o.name === PEAR_ASSESSMENT_CERTIFIED_NAME) &&
            getAuthorCollectionMap(false, 30, 30).edulastic_certified.icon}
          {/* hiding premium tag temporarily as per CR */}
          {/* {showPremiumTag && <PremiumLabel> PREMIUM</PremiumLabel>} */}
          <EduIf condition={isDocBased}>
            <EduIf condition={videoUrl}>
              <EduThen>
                <StyledIcon type="play-square" />
              </EduThen>
              <EduElse>
                <StyledIcon type="file-pdf" />
              </EduElse>
            </EduIf>
          </EduIf>
        </Header>
        <TestInfo>
          <TitleRow>
            {showBulkDistrictCheckbox && (
              <CheckboxStopPropagation
                title="Select to move to district"
                onClick={stopCardOpen}
                onMouseDown={stopCardOpen}
              >
                <Checkbox
                  checked={!!checked}
                  onChange={onCheckboxChange}
                  disabled={districtMoveInProgress}
                  data-cy="test-card-checkbox"
                />
              </CheckboxStopPropagation>
            )}
            <StyledLink ref={ref} data-cy="test-title" title={title}>
              {title}
            </StyledLink>
          </TitleRow>
          <TagsWrapper testNameHeight={height} data-cy="test-standards">
            <Tags
              show={2}
              tags={standardsIdentifiers}
              key="standards"
              isStandards
              margin="0px"
              isTestCard
              flexWrap="noWrap"
              testId={testId}
            />
          </TagsWrapper>
        </TestInfo>

        {!isTestRecommendation && (
          <MidRow isTest>
            <Collection isDynamicTest={isDynamicTest}>
              <label>COLLECTIONS</label>
              <CollectionNameWrapper
                data-cy="test-collection"
                title={collectionName}
              >
                {collectionName}
              </CollectionNameWrapper>
            </Collection>
            <Qcount>
              <label>{isDocBased ? 'TOTAL QUESTIONS' : 'TOTAL ITEMS'}</label>
              {/**
               * For doc based wee need to consider
               *  total number questions and toal number of items
               *  */}
              <div data-cy="test-item-count">
                {isDocBased ? summary.totalQuestions : summary.totalItems}
              </div>
            </Qcount>
            {isDynamicTest && (
              <DynamicIconWrapper title="SmartBuild Test. Every student might get different items in assignment">
                <IconDynamic color={themeColor} />
              </DynamicIconWrapper>
            )}
          </MidRow>
        )}
      </OnHoverContainer>
      {!isTestRecommendation && (
        <Inner isTest>
          {authorName && (
            <Author>
              <AuthorWrapper>
                {collections.find(
                  (o) => o.name === PEAR_ASSESSMENT_CERTIFIED_NAME
                ) ? (
                  getAuthorCollectionMap(true, 30, 30).edulastic_certified.icon
                ) : (
                  <IconUser color={cardTitleColor} />
                )}
                <AuthorName data-cy="test-author-name" title={authorName}>
                  {authorName}
                </AuthorName>
              </AuthorWrapper>
            </Author>
          )}
          <StatusRow>
            <TestStatusWrapper status={status} checkUser={false}>
              {({ children, ...rest }) => (
                <TestStatus data-cy="test-status" {...rest} view="tile">
                  {children}
                </TestStatus>
              )}
            </TestStatusWrapper>
          </StatusRow>
        </Inner>
      )}

      {!isTestRecommendation && (
        <Footer height="33px">
          {testItemId ? (
            <PlaylistId data-cy="test-id">
              <span>#</span>
              <span>{testItemId}</span>
            </PlaylistId>
          ) : null}
          {status !== 'draft' && (
            <>
              <ShareIcon aria-label={`Used ${usage} times.`}>
                <IconUsers width={14} height={14} aria-hidden /> &nbsp;
                <IconText aria-hidden>{usage}</IconText>
              </ShareIcon>
              <LikeIconStyled
                tabIndex={0}
                role="button"
                aria-pressed={isTestLiked}
                title={isTestLiked ? 'Unlike' : 'Like'}
                isLiked={isTestLiked}
                onClick={handleLikeTest}
                onKeyDown={(e) => onEnterKeyPressHandler(e, handleLikeTest)}
                aria-label={
                  isTestLiked
                    ? `Unlike this test. It has ${likes} likes.`
                    : `Like this test. It has ${likes} likes.`
                }
              >
                <IconHeart
                  color={
                    isTestLiked
                      ? '#ca481e'
                      : accessibilityColors.testLibrary.footerIconText
                  }
                  width={14}
                  height={14}
                  aria-hidden
                />
                <IconText aria-hidden>{likes}</IconText>
                {isTestLiked && (
                  <span style={{ position: 'absolute', left: '-9999px' }}>
                    Liked by me
                  </span>
                )}
              </LikeIconStyled>
            </>
          )}
          <AddRemoveTest testDetail={{ itemId: testId, name: title }} />
        </Footer>
      )}
    </Container>
  )
}

export default TestItemCard

const TitleRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 100%;

  ${StyledLink} {
    flex: 1;
    min-width: 0;
  }
`

/** Wraps checkbox only so title clicks still bubble to card openModal */
const CheckboxStopPropagation = styled.span`
  flex-shrink: 0;
  margin-top: 2px;

  .ant-checkbox-wrapper {
    margin-right: 0;
  }

  /* Same filled checked look while disabled (in progress); white tick, not blue/black */
  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${themeColor} !important;
    border-color: ${themeColor} !important;
  }

  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
    border-color: #fff !important;
  }
`

const OnHoverContainer = styled.div`
  &:hover {
    .showHoverTestCard {
      display: flex;
      justify-content: space-around;
      align-items: center;
      flex-direction: column;
      padding: 30px 0px;
    }
  }
`
